import { render } from "./EnrollmentSummary.vue?vue&type=template&id=4b6efdb7&ts=true"
import script from "./EnrollmentSummary.vue?vue&type=script&lang=ts"
export * from "./EnrollmentSummary.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__